import React from "react";
import PropTypes from "prop-types";
import { useLightTheme } from "../../hooks/useLightTheme";

function getRandomColor() {
  let colors = ["#0099ce", "#ff664e", "#f5967b", "#42b77a"];
  return colors[Math.round(Math.random() * (colors.length - 1))];
}

function UserAvatar(props) {
  const lightTheme = useLightTheme();

  const circleStyle = {
    ...styles.circle,
    backgroundColor: lightTheme ? "#C3DDFD" : styles.circle.backgroundColor
  };

  const initialsStyle = {
    ...styles.initials,
    color: lightTheme ? "#233876" : styles.initials.color
  };

  return (
    <div style={circleStyle}>
      <p style={initialsStyle} data-testid="initials">
        {props.firstName?.charAt(0)}
        {props.lastName?.charAt(0)}
      </p>
    </div>
  );
}

UserAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string
};

const styles = {
  circle: {
    width: "100px",
    height: "100px",
    borderRadius: "100px",
    backgroundColor: getRandomColor()
  },
  initials: {
    color: "#233876",
    fontFamily: "Open Sans",
    fontWeight: "400",
    textAlign: "center",
    fontSize: "41px",
    paddingTop: "37px"
  }
};

export default UserAvatar;
